// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2521":"e7720c6d133057fc","2888":"eb012e0d057101a4","6283":"e7720c6d133057fc","6427":"e7720c6d133057fc","9225":"e7720c6d133057fc"}[chunkId] + ".css";
};